import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import LockIcon from '@assets/img/icons/lock.svg?react';
import cn from 'classnames';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';

import css from './styles.module.scss';

interface LockResourceProps {
  className?: string;
  minLevel?: number;
  image:
    | {
        img: string;
        webp?: string;
        pngRight?: string;
        webpRight?: string;
      }
    | undefined;
}

const LockResource: FC<LockResourceProps> = ({ className, minLevel }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('card-resource lock-Resource isolate', className)}>
      <div className={css.content}>
        <LockIcon
          width={convertRemToPixels(1.5)}
          height={convertRemToPixels(1.5)}
          className="relative z-[2]"
        />
        <p className={css.unlockText}>
          {t('Available Level')} {minLevel}
        </p>
      </div>
      {/* <div className="card-resource__icon">
        <picture>
          <source srcSet={image?.webpRight || image?.webp} type="image/webp" />
          <img width={72} src={image?.pngRight || image?.img} alt="icon" />
        </picture>
      </div> */}
    </div>
  );
};

export { LockResource };
